import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import { AFFILIATE_CREATIVES_LINK_ROUTE_NAME, CREATIVES_LINK_PERMISSIONS } from '@modules/creatives-link/constants';
import {
  AFFILIATE_CREATIVES_LINK_TABLE_ROUTE_NAME,
  TRANSLATION_GROUP_CREATIVES_LINK_TABLE,
} from '@modules/creatives-link/submodules/constants';
import getTranslationKeys from '@modules/creatives-link/submodules/translations';

export class CreativesLinkTableModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(AFFILIATE_CREATIVES_LINK_ROUTE_NAME, {
      name: AFFILIATE_CREATIVES_LINK_TABLE_ROUTE_NAME,
      path: 'list/:merchant/:dealType/:serialId:/:format/:language/:creativeAdvertisingCompanyId/:creativeResolutionId?',
      permission: CREATIVES_LINK_PERMISSIONS.SHOW,
      component: () => import('@modules/creatives-link/submodules/pages/CreativesLinkTablePage/CreativesLinkTablePage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_CREATIVES_LINK_TABLE, getTranslationKeys);
  }
}
